module.exports = __webpack_public_path__ + "static/media/AdobeStock_224927508 (2).78fead25.mov";